import * as R from 'ramda'
import React from 'react'
import { Question } from '../Question/Question'
import { List } from 'components/shared/List/List'

export const Questions = ({ questions, isWordDoc }) => (
  <List direction="column">
    {R.map(
      ({ description, id, title, order }) => (
        <Question {...{ title, description, order, isWordDoc }} key={id} />
      ),
      questions,
    )}
  </List>
)
